<div class="d-flex flex-column align-items-center">
  <img
    src="assets/images/warning_icon.svg"
    alt="error"
    class="mb-3"
    width="50px"
    height="73px"
  />
  <p class="text-center fw-500 text-base">
    {{ "error.update-app" | translate }}
  </p>
  <div>
    <!-- <button class="btn btn-primary" (click)="openDownloadLink()">
      {{ "buttons.update" | translate }}
    </button> -->
  </div>
</div>
